import React, { useState, useEffect } from "react";


export const DropDownRender = (props) => {
  const [selectedVal, setSelectedVal] = useState(null);
  const { dataPropName } = props;

  const onValueChange = (e) => {
    let data = props.data;
    data[dataPropName] = e.target.value
    props.onChange(data);
    setSelectedVal(data[dataPropName])
  }

  useEffect(() => {
    let data = props.data;
    setSelectedVal(data && data[dataPropName] || null);
  }, [])

  return (
    <div className="agDropDown">
      {props.node.group === false ? <>
        <select className="roleSelect" value={selectedVal} onChange={onValueChange} options={props.optionsList}>
          {props.optionsList.map(el => (
            <option value={el}>{el || "--"}</option>
          ))}
        </select>
      </> : null}
    </div>
  );
}

//const mapStateToProps = ({ BillingServicesReducer }) => ({ BillingServicesReducer });
export default DropDownRender //connect(mapStateToProps, { UpdateBillingServices })();